import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthComponent } from './auth.component';
import { SignInComponent } from './sign-in/sign-in.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmationCodeComponent } from './confirmation-code/confirmation-code.component';
import { ClarityModule } from '@clr/angular';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AuthSplitScreenComponent } from './components/auth-split-screen/auth-split-screen.component';
import { SsoRedirectComponent } from './sso-redirect/sso-redirect.component';
import { SsoSignoutComponent } from './sso-signout/sso-signout.component';
import { SsoInvalidComponent } from './sso-invalid/sso-invalid.component';

@NgModule({
  declarations: [
    AuthComponent,
    SignInComponent,
    SignUpComponent,
    SsoRedirectComponent,
    ConfirmationCodeComponent,
    ResetPasswordComponent,
    AuthSplitScreenComponent,
    SsoSignoutComponent,
    SsoInvalidComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ClarityModule,
    FontAwesomeModule,
  ],
})
export class AuthModule {}
